const initPlacemarks = ( yandexMapHelper ) => {
	const iconSize = 40;
	
	const placemarkManagerOptions = {
		clusterize: true,
		gridSize: 128,
		margin: 0,
		clusterDisableClickZoom: false,
		clusterIconLayout: yandexMapHelper.ymaps.templateLayoutFactory.createClass(
			`<div class="infrastructure-placemark-cluster"
				data-infrastructure-cluster-id="$[id]"
				style="background-color: $[properties.geoObjects.0.properties.color];"
			>
				$[properties.geoObjects.length]
			</div>`
		),
		clusterIconShape: {
			type: `Rectangle`,
			coordinates: [
				[0, 0], [iconSize, iconSize]
			]
		},
		
		zIndex: 1,
	};
	
	// objectManagers by placemarktypes
	const managersByTypes = {};
	
	const placemarkPropsByTypes = {};
	
	Array.from(
		yandexMapHelper.component
			.querySelectorAll( `ul.filters > li > input[id*="infrastructure-type"]:not(#infrastructure-type-all)` )
	).forEach(
		( item ) => {
			const placemarksManager = yandexMapHelper.createObjectManager(
				item.id,
				placemarkManagerOptions
			);
			
			placemarksManager.events.add( [`mouseenter`, `mouseleave`], ( evt ) => {
				const type = evt.get( `type` );
				const currentObjectId = evt.get( `objectId` );
				
				const markerSelector = `.infrastructure-placemark-wrapper[data-infrastructure-marker-id="${currentObjectId}"]`;
				let mapPoint = yandexMapHelper.mapContainer.querySelector( markerSelector );
				
				if ( !mapPoint )
				{
					const clusterSelector = `.infrastructure-placemark-cluster[data-infrastructure-cluster-id="${currentObjectId}"]`;
					mapPoint = yandexMapHelper.mapContainer.querySelector( clusterSelector );
				}
				
				if ( mapPoint )
				{
					if ( type === `mouseenter` )
					{
						mapPoint.classList.add( `hover` );
					}
					
					if ( type === `mouseleave` )
					{
						mapPoint.classList.remove( `hover` );
					}
				}
			} );
			
			const placemarkProps = {
				color: item.dataset.placemarkTypeColor,
				icon: item.dataset.placemarkTypeIcon,
			};
			
			managersByTypes[item.id] = placemarksManager;
			placemarkPropsByTypes[item.id] = placemarkProps;
		},
		{}
	);
	
	Array.from(
		yandexMapHelper.component.querySelectorAll( `ul.placemarks > li` )
	).forEach( ( item ) => {
		const manager = managersByTypes[item.dataset.type];
		const {color, icon} = placemarkPropsByTypes[item.dataset.type];
		
		const placemarkProps = {
			type: `Feature`,
			id: item.dataset.id,
			geometry: {
				type: `Point`,
				coordinates: [item.dataset.latitude, item.dataset.longitude],
			},
			properties: {
				color: color,
				balloonContent: item.dataset.content
			},
			options: {
				iconLayout: yandexMapHelper.ymaps.templateLayoutFactory.createClass(
					`<div class="infrastructure-placemark-wrapper"
						data-infrastructure-marker-id="${item.dataset.id}"
						style="background-color: ${color}; background-image: url(${icon});"
					>
					</div>`
				),
				iconOffset: [iconSize / -2, iconSize / -2],
				iconShape: {
					type: `Rectangle`,
					coordinates: [
						[0, 0],
						[iconSize, iconSize]
					]
				},
				
				hideIconOnBalloonOpen: true,
				balloonShadow: false,
				balloonPanelMaxMapArea: 0,
				balloonAutoPanMargin: 0,
				balloonLayout: yandexMapHelper.ymaps.templateLayoutFactory.createClass(
					`<div class="infrastructure-placemark-balloon-wrapper">
						<div class="infrastructure-placemark-balloon"
							style="border-color: ${color};"
						>
							<div class="icon"
								style="background-color: ${color}; background-image: url(${icon});"
							></div>
							<p class="info" style="border-color: ${color};">
								${item.dataset.content}
							</p>
						</div>
					</div>`,
					{
						build() {
							this.constructor.superclass.build.call( this );
							
							const balloonSelector = `div.infrastructure-placemark-balloon`;
							const balloonWrapper = this.getElement().querySelector( balloonSelector );
							const icon = this.getElement().querySelector( `${balloonSelector} div.icon` );
							
							if ( icon )
							{
								const balloonClickHandler = () => {
									if ( yandexMapHelper.isTouch() )
									{
										icon.removeEventListener( `click`, balloonClickHandler );
										yandexMapHelper.closeBalloon();
									}
								};
								
								/* setTimeout добавлен из-за глюков яндекса - быстрого закрытия балуна */
								setTimeout(
									() => {
										icon.addEventListener( `click`, balloonClickHandler );
									},
									100
								);
							}
							
							if ( balloonWrapper )
							{
								const balloonWidth = balloonWrapper.offsetWidth;
								const iconWidth = icon.offsetWidth;
								const height = balloonWrapper.offsetHeight;
								
								const shapeCoordinates = [
									[iconWidth / -2, -1 * height],
									[(balloonWidth - iconWidth / 2), 0]
								];
								
								const shapeRectangle = {
									type: `Rectangle`,
									coordinates: shapeCoordinates,
								};
								
								this.getData().options.set( `shape`, shapeRectangle );
								
								balloonWrapper.style.setProperty( `position`, `absolute` );
								balloonWrapper.style.setProperty( `left`, `${iconWidth / -2}px` );
								balloonWrapper.style.setProperty( `top`, `${height / -2}px` );
							}
						}
					}
				),
				
				zIndex: 1,
			}
		};
		
		manager.add( placemarkProps );
	} );
	
	return managersByTypes;
};

export {
	initPlacemarks,
};
